// Where the shared app runtime (ADR 0018) is, for the Prototype page and the Apps pages.

/** The meta element the web server writes the runtime's origin into (@cortex/web-host withRuntimeMeta). */
export const RUNTIME_META = 'app-runtime-origin';

/**
 * The runtime's origin: the page's `<meta name="app-runtime-origin">` when the server wrote one, else
 * `configured` (the build's VITE_PROTOTYPE_RUNTIME_URL; `/` = `origin`, this page's own). No trailing slash.
 * Empty when neither names one: the deployment has no app runtime.
 */
export function resolveRuntimeBase(
  configured: string,
  doc: Pick<Document, 'querySelector'> | undefined,
  origin: string,
): string {
  const meta = doc?.querySelector<HTMLMetaElement>(`meta[name="${RUNTIME_META}"]`)?.content.trim();
  const value = meta || configured;
  return value === '/' ? origin : value.replace(/\/+$/, '');
}
